<template>
  <div class="h5">
    <div class="wrap">
      <div class="container">
        <div class="content">
          <h1 class="content_title">《心潮服务协议》</h1>
          <div class="content_body">
            <p style="text-align: center">
              <span style="font-weight:700">心潮科技用户服务协议</span>
            </p>
            <p style="text-align: left">发布时间：2019年05月28日<br/>
              生效时间：2019年05月28日<br/>
              更新时间：2021年12月15日</p>
            <p>
              <span>欢迎您使用心潮科技的服务！</span>
            </p>
            <p>
              <span style="font-weight:700">特别提醒：当您开始使用心潮服务时即代表您已阅读并决定接受《心潮服务协议》（“本协议”）。若您对本协议存在疑问，或者无法全部或者部分接受本协议，或者在使用心潮过程中需要向心潮科技反馈（含建议、投诉、举报等），请毫不迟疑地与心潮科技取得联系：邮箱：office@heartide.com。</span>
            </p>
            <p>
              <span style="font-weight:700">1.本协议及定义：</span>
            </p>
            <p>
              <span>(1) 本协议是您与心潮科技之间关于您使用心潮相关服务所订立的协议。心潮科技可能根据自身对商业、适用法律与政策等要素的判断，随时更新本协议；若您无法接受本协议或本协议未来更新版本的全部或者部分条款，可联系心潮科技，在您未与心潮科技沟通一致前，请暂停使用心潮。</span>
            </p>
            <p>
              <span>(2) 心潮：为心潮科技开发、运营、管理的一款应用软件产品，旨在为您提供本协议范围内免费、非独占和全球范围内的软件使用许可及技术服务。本协议项下的“心潮”根据不同的语境将可能指心潮移动端、心潮小程序、心潮独立网站或者心潮科技围绕心潮软件产品提供的相关技术服务。</span>
            </p>
            <p>
              <span>(3) 心潮科技：涉及（且仅在涉及）到心潮科技依据本协议可享有的权利时，本协议项中所指“心潮科技”指广州心与潮信息科技有限公司。</span>
            </p>
            <p>
              <span>(4) 素材：指由心潮科技提供的已经内置于心潮的或者未来即将内置的包括但不限于音频、字体、文字、说明、动画等用于帮助您睡眠、放松等的相关素材与信息。</span>
            </p>
            <p>
              <span style="font-weight:700">2.知识产权声明：</span>
            </p>
            <p>
              <span>心潮本身自带的所有版本、技术、程序、素材和所有的信息内容（信息内容，包括但不限于产品功能、用户界面、操作步骤、商标、专利、计算机软件作品）的知识产权均归心潮科技所有，心潮科技对您的软件使用许可在任何情况下均不应视为向您转让心潮知识产权的部分或者全部。您通过心潮下载、使用的任何素材及其他信息内容，仅限您个人娱乐、学习、研究、训练或者欣赏使用，未经心潮科技书面同意，不可用于任何商业用途。</span>
            </p>
            <p>
              <span style="font-weight:700">3.您的必要授权：</span>
            </p>
            <p>
              <span>您同意授予心潮科技一项为提供本服务、优化本服务和宣传推广本服务之目的所必须的免费、非独占、不可撤销的可在全球范围内使用您在本服务过程中产生信息内容的权利。心潮科技将尽最大努力在合理范围内使用上述信息内容，且您的必要授权并不代表心潮科技对上述信息内容的必然使用。</span>
            </p>
            <p>
              <span style="font-weight:700">4.个人信息保护：</span>
            </p>
            <p>
              <span>保护您的个人信息是心潮科技的一项基本原则。心潮科技将按照本协议规定收集、使用、存储和管理您的个人信息。</span>
            </p>
            <p>
              <span style="font-weight:700">5.您的合法使用：</span>
            </p>
            <p>
              <span>您不得使用心潮制作、储存或发布如下信息内容：</span>
            </p>
            <p>
              <span>(1) 危害国家及社会安全信息，其表现可能包括但不限于反对宪法所确定的基本原则；危害国家安全，泄露国家机密，颠覆国家政权，破坏国家统一；煽动民族仇恨、民族歧视，破坏民族团结；破坏国家宗教政策，宣扬邪教和封建迷信；散布谣言，扰乱社会秩序，破坏社会稳定；宣扬赌博、暴力、凶杀、恐怖或者教唆犯罪；煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；含有法律、行政法规和国家规定禁止的其他内容。</span>
            </p>
            <p>
              <span>(2) 淫秽色情信息，其表现可能包括但不限于发布淫秽、色情内容，包括但不限于招嫖、寻找一夜情、性伴侣等内容；发布以色情为目的的情色文字、情色视频、情色图画等内容；长期发布与淫秽、色情内容擦边的或具有性暗示类的内容。</span>
            </p>
            <p>
              <span>(3) 侵权信息，其表现可能包括但不限于制作、发布、储存侵犯他人名誉权、肖像权、隐私权、知识产权等合法权利的内容。</span>
            </p>
            <p>
              <span>(4) 不正当竞争信息，其表现可能包括但不限于发布篡改、增减、删除权利标识的内容；发布未经授权方授权的内容等。</span>
            </p>
            <p>
              <span>(5) 其他违反法律法规、政策以及社会公序良俗或干扰心潮正常运营及侵犯任何第三方合法权益的信息。</span>
            </p>
            <p>
              <span> 如您有上述违法或侵害他人合法权利的行为，心潮科技有权立即采取适当措施，包括但不限于：删除该等违法信息内容，终止对您的软件使用许可并停止所有技术服务，诉诸执法机构或司法机关等。若因您违法或不当使用心潮而造成的自身损失或对心潮科技和/或第三方造成损害的，您须自行承担所有责任。</span>
            </p>
            <p>
              <span style="font-weight:700">6.广告业务许可：</span>
            </p>
            <p><span>
                        心潮中可能包括广告，这属于心潮科技合理合法的商业模式，您同意在使用心潮过程中接收由心潮科技与第三方合作伙伴发布的广告信息。
                    </span></p>
            <p>
              <span style="font-weight:700">7.不可抗力与其他免责事由：</span>
            </p>
            <p><span>
                        心潮在使用中会受到包括但不限于如下不可抗力或者其他因素的影响：政治原因、社会环境、自然灾害、经济危机、计算机病毒或黑客攻击、服务器或系统不稳定、您所在的特殊位置、任何技术能力、网络质量以及通信线路、计算机故障等（以下统称“免责事由”）。若出现上述免责事由情况时，心潮科技将尽努力在第一时间进行修复或者及时补救，给您造成损失的，心潮科技在适用法律与政策允许的范围内免责。
                    </span></p>
            <p>
              <span style="font-weight:700">8.适用法律与政策：</span>
            </p>
            <p><span>
                        与本协议有关的事项，均应适用中华人民共和国（但不含港澳台地区）的法律与政策。该等适用法律与政策可能处于动态变化过程中，因此，若因适用法律与政策发生变化，导致您和/或心潮科技在本协议项下的权益有所增减，均不构成本协议的全部或某个条款自然无效或终止可执行性的依据，除非发生变化的该等适用法律与政策属于效力性强制性规定。
                    </span></p>
            <p>
              <span style="font-weight:700">9.法律纠纷管辖：</span>
            </p>
            <p><span>
                        若在您与心潮科技之间出现了与本协议和/或与心潮有关的法律纠纷，只要发生纠纷时本协议适用法律与政策允许将广州心与潮信息科技有限公司所在地作为唯一或其中之一的纠纷管辖地的，则您同意由广州心与潮信息科技有限公司所在地有管辖权的人民法院排他管辖该纠纷。
            </span></p>
            <p><span>
              心潮科技可能不时发布针对用户的相关协议，并可能将该相关协议作为对本协议的补充或修改而将其内容作为本协议的一部分。请您及时关注并阅读相关协议。
            </span></p>
            <p><span>
              本协议任意一条被视为废止、无效或不可执行，该条款应视为可分的且不影响本协议其他条款的法律效力。
            </span></p>
            <p><span>
              请您再次确认您已全部阅读并充分理解上述协议。
            </span></p>
            <p style="text-align: right;font-weight: 700">广州心与潮信息科技有限公司<br/>
              2021年12月15日</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'yinsi',
  mounted () {
    document.getElementsByTagName("title")[0].innerHTML="&#65279;"
  }
}
</script>

<style lang="scss">
  .h5 .content_title {
    display: none
  }
  .h5 p{
    padding: 10px 0;
  }
  p {
    font-size: 14px;
  }
  .wrap{
    text-align: left;
    box-sizing: border-box;
    padding: 10px 10px 200px 10px;
  }
</style>
